/* jshint esversion: 11 */

// Die Startseite aus ziege.html.in: Sie steht da, bis Elm die Seite übernimmt oder
// die Anmeldung erscheint. Fehlt sie, laufen die Aufrufe ins Leere.

function setText(id, text) {
    const element = document.getElementById(id);
    if (element) {
        element.textContent = text;
        element.hidden = !text;
    }
}

export function showStartupStatus(text) {
    setText("startup-status", text);
}

export function showStartupAccount(userId, deviceId) {
    setText("startup-account", `${userId} · Geräte-ID ${deviceId}`);
}

export function showStartupWarning(text) {
    setText("startup-warning", text);
}

export function showStartupReload(visible) {
    const button = document.getElementById("startup-reload");
    if (button) {
        button.hidden = !visible;
        button.onclick = () => window.location.reload();
    }
}
